"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginAlert = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = require("react");
var Alert_1 = require("@components/case/login/Alert");
var useLogin_1 = require("@store/login/useLogin");
var LoginAlert = function () {
    var _a = (0, useLogin_1.useLogin)(), error = _a.error, isShowCompleteNotice = _a.isShowCompleteNotice, updateShowCompleteNotice = _a.updateShowCompleteNotice;
    (0, react_1.useEffect)(function () {
        updateShowCompleteNotice();
        // eslint-disable-next-line react-hooks/exhaustive-deps -- 暫定対応
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, { children: [isShowCompleteNotice && ((0, jsx_runtime_1.jsx)(Alert_1.AlertSuccess, { message: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u518D\u8A2D\u5B9A\u3057\u307E\u3057\u305F\u3002" })), error && ((0, jsx_runtime_1.jsx)(Box_1.default, { mt: 3, children: (0, jsx_runtime_1.jsx)(Alert_1.AlertError, { message: error }) }))] }));
};
exports.LoginAlert = LoginAlert;
